import React, { useState } from "react";
import { Button, Checkbox, Col, Divider, Row, Transfer, Tree } from "antd";
import { Card, CardBody, CardHeader } from "reactstrap";
import { gql, useMutation, useQuery } from "@apollo/client";
import moment from "moment-jalaali";
import { error } from "../../Controllers/toast";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const GET_OPTIMIZERS = gql`
  mutation Optimizer($poInput: [POListsInput], $type: [String]) {
    GetOptimizersAnalysisData(POInput: $poInput, type: $type) {
      PO_id
      production {
        Vpv
        Ipv
        Vbat
        Vo
        Ibat
        Ein
        Temp
        SOC
        date_time
      }
    }
  }
`;
const TransferCompare = ({
  PO_groups,
  targetKeys,
  setChartData,
  dateHOC,
  children,
  setModal,
}) => {
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [showItem, setShowItem] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [loading, setLoading] = useState(false);
  const lang_choiced = useSelector((state) => state.lang_change);

  const [getOptimizers] = useMutation(GET_OPTIMIZERS, {
    onCompleted: async (res) => {
      // console.log(res, "is result");
      // const {
      //   production,

      //   PO_id,

      // } = res.GetOptimizersAnalysisData[0];
      // setPowerOptimizer({

      //   PO_id,
      // });

      const createChartData = await res.GetOptimizersAnalysisData.map(
        ({ production }) => {
          return production.map((product) => {
            let newDate = new Date(parseInt(product.date_time));
            let dateChart = new Date(
              moment(newDate).format("jYYYY-jMM-jDDTHH:mm:ss")
            );
            // console.log(product.SOC)

            // let dateSlider = moment(newDate).format("YYYY-MM-DD HH:mm");

            return {
              Vpv: product.Vpv ? product.Vpv / 100 : null,
              Vbat: product.Vbat ? product.Vbat / 100 : null,
              Vo: product.Vo ? product.Vo / 10 : null,
              Ipv: product.Ipv ? product.Ipv / 1000 : null,
              Ibat: product.Ibat ? product.Ibat / 1000 : null,
              Ppv:
                product.Ipv && product.Vpv
                  ? Math.round((product.Ipv * product.Vpv) / 100000)
                  : null,
              Pbat:
                product.Ibat && product.Vbat
                  ? Math.round((product.Ibat * product.Vbat) / 100000)
                  : null,
              Pnet:
                product.Ibat && product.Vbat && product.Ipv && product.Vpv
                  ? Math.round((product.Ipv * product.Vpv) / 100000) +
                  Math.round((product.Ibat * product.Vbat) / 100000)
                  : null,
              Temp: product.Temp ? Math.round(product.Temp / 10) / 10 : null,
              SOC: product.SOC ? product.SOC / 100 : null,
              date: dateChart,
            };
          });
        }
      );

      // console.log(createChartData);
      targetKeys({ data: createChartData }, checkedKeys, showItem);
      setLoading(false);
      setModal(false);
      // setDateHOC()
    },
    onError: (err) => {
      console.log(err);
      error("مشکلی در دریافت اطلاعات رخ داده است!");
      setLoading(false);
    },
  });

  // //console.log(
  //   PO_groups.map((group) => {
  //     return {
  //       title: `0-${group.Opt_Group_id}`,
  //       key: group.Opt_Group_id,
  //       children:group.optimizers.map(({PO_id},key) => {
  //         return {
  //           title: `0-0-${key}`,
  //           key: PO_id,
  //         }
  //       })
  //     };
  //   })
  // );

  const onExpand = (expandedKeys) => {
    // //console.log("onExpand", expandedKeys); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.

    setExpandedKeys(expandedKeys);
    setAutoExpandParent(true);
  };

  const onCheck = (checkedKeys, info, s) => {
    // //console.log("onCheck", checkedKeys);
    // console.log("onCheck", checkedKeys , info , s);

    setCheckedKeys(checkedKeys);
  };

  const onSelect = (selectedKeys, info) => {
    // //console.log("onSelect", info , selectedKeys);
    setSelectedKeys(selectedKeys);
  };

  const handleClick = () => {
    setLoading(true);
    // var arr = []
    // checkedKeys.map((word) => {
    //   var res2 = word.split("-");
    //   if (res2.length > 2) {
    //     arr.push(word);
    //   console.log("pannel", res2);
    //   } else if (res2.length < 3) {
    //     // arr.push(word);
    //   console.log("string", res2);
    //   }
    // });
    // console.log(
    //   dayjs(dateHOC[0], { jalali: true }).format("YYYY-MM-DDTHH:mm:ss"),
    //   "is dateHoc"
    // );
    const EngDate = [
      moment(
        dayjs(dateHOC[0], { jalali: true }).format("YYYY-MM-DDTHH:mm:ss"),
        "jYYYY-jMM-jDDT00:00:00"
      ).format("YYYY-MM-DDTHH:mm:ss"),
      moment(
        dayjs(dateHOC[1], { jalali: true }).format("YYYY-MM-DDTHH:mm:ss"),
        "jYYYY-jMM-jDDT00:00:00"
      ).format("YYYY-MM-DDTHH:mm:ss"),
    ];

    // console.log(EngDate);
    // setCheckedKeys(checkedKeys.filter((key, index) => {
    //   const id = parseInt(key.split("/")[0]);
    //   if(id!==-1){

    //     return true;
    //   }
    //   return false
    //   //   console.log(id , "is sending id");
    // }))
    const result = [];
    const newCheckedKeys = [];
    checkedKeys.map((key, index) => {
      const id = parseInt(key.split("/")[0]);
      if (id !== -1) {
        result.push({
          PO_id: id,
          date: EngDate,
          offset_date: new Date().getTimezoneOffset(),
        });
        newCheckedKeys.push(key);
      }
      //   console.log(id , "is sending id");
    });

    setCheckedKeys(newCheckedKeys);
    // console.log(result, "is result");
    // console.log(result , 'is result')
    //   console.log(checkedKeys, "is keys", finilizedKeys);
    getOptimizers({
      variables: {
        poInput: result,
        type: showItem,
      },
    });
    // checkedKeys = arr

    // targetKeys(checkedKeys);
    // getOptimizer({
    //   variables: {
    //     PO_id: optimizer.PO_id,
    //     date: moment(date, "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
    //   },
    // });
    // if(checkedKeys.length!==num){
    //   var date = new Date()
    // //console.log(date , moment(date).format("YYYY-MM-DD"));
    //   getOptimizer({
    //     variables: {
    //       PO_id: checkedKeys[checkedKeys.length-1],
    //       date:  moment(date).format("YYYY-MM-DD"),
    //     },
    //   });

    // }
  };

  return (
    <div className="h-100">
      {/* <CardHeader className="text-center">
        <h5>مقایسه نموداری</h5>
      </CardHeader> */}
      {/* <CardBody className="h-100"> */}
      {children}
      <div className="h-100">
        <Tree
          className="h-75"
          checkable
          treeDefaultExpandAll={true}
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          onCheck={onCheck}
          checkedKeys={checkedKeys}
          onSelect={onSelect}
          selectedKeys={selectedKeys}
          treeData={PO_groups.map((group, index) => {
            return {
              title: `0-${index}`,
              key: `-1/${group.Opt_Group_id}-group-id`,
              checkable: true,
              children: group.optimizers.map((opt, key) => {
                // console.log(opt)
                return {
                  title: `${index}-0-${key + 1} (${opt.serial_number})`,
                  key: `${opt.PO_id}/${index}-0-${key + 1}`,
                };
              }),
            };
          })}
        />
        <div>
          <Divider className="mt-0" />
          <div className="">
            <Checkbox.Group
              style={{
                width: "100%",
              }}
              onChange={(e) => {
                console.log(e);
                setShowItem(e);
              }}
            >
              <Row
                className={`${window.document.documentElement.lang === "fa"
                    ? "text-right"
                    : "text-left"
                  }`}
              >
                <Col span={24}>
                  <Checkbox value="Ipv">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.I
                    }
                  </Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Vpv">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.V
                    }
                  </Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Ppv">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.P
                    }
                  </Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Ibat">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Ibat
                    }
                  </Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Vbat">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Vbat
                    }
                  </Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Pbat">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Pbat
                    }
                  </Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Vo">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Vo
                    }
                  </Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Pnet">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Pnet
                    }
                  </Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="SOC">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.SOC
                    }
                  </Checkbox>
                </Col>
                <Col span={24}>
                  <Checkbox value="Temp">
                    {
                      lang_choiced.pages.byPanel.PanelGroup.Line.Modal
                        .seriesName.Temp
                    }
                  </Checkbox>
                </Col>
              </Row>
            </Checkbox.Group>
          </div>
          <Divider className="mt-0" />
          <div className="text-center">
            <Button
              block
              loading={loading}
              type="primary"
              className="full-width"
              onClick={() => handleClick()}
              disabled={
                showItem.length > 0 &&
                  dateHOC.length > 0 &&
                  checkedKeys.length > 0
                  ? false
                  : true
              }
            >
              {
                lang_choiced.pages.compare_panel.modal.btnAccept
              }
            </Button>
          </div>
        </div>
      </div>
      {/* </CardBody> */}
    </div>
  );
};

export default TransferCompare;
